import { useRef } from 'react';

import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button
} from '@chakra-ui/react';

import { Markup } from 'interweave';

/**
 *  EXAMPLE OF HOW TO CALL
 * 

    const commonMethodsRef = useRef(commonMethods);
    commonMethodsRef.current = commonMethods;

        let overridePromise = new Promise((resolve, reject) => {
            commonMethodsRef.current.createDialog({
                header:"hey 2", 
                body:"nice body 2",
                
                confirmFunc: () => {
                    resolve(true);
                },
                declineFunc: () => {
                    resolve(false);
                }
                
            });
        });

        const overrideResponse = await overridePromise;
        if (overrideResponse) {
            commonMethodsRef.current.createDialog({
                header:"success", 
                body:"nice success",
            });
        } else {
            commonMethodsRef.current.createDialog({
                header:"failure", 
                body:"nice failure",
            });
        }


 * 
 * 
 *  **/


export function AlertWrapper({commonMethods, alertList}) {

    try {
        return (
            <>
                {
                alertList && Object.keys(alertList)?.length > 0
                    ?
                        Object.keys(alertList)?.map((alertId) => (
                            <AlertComponent key={alertId} commonMethods={commonMethods} alertList={alertList} alertId={alertId}/>
                        ))
                    :
                        []
                }
            </>
        );
    } catch (e) {
        console.error("AlertWrapper render error: ", e);
    }
}

function AlertComponent({commonMethods, alertList, alertId}) {
    const cancelRef = useRef();

    const closeAlert = () => {
        commonMethods.closeDialog(alertId);
        //onClose();
    };

    const handleDecline = async () => {
        if (alertList?.[alertId]?.declineFunc) {
            await alertList[alertId].declineFunc();
        }
        closeAlert();
    };

    const handleConfirm = async () => {
        if (alertList?.[alertId]?.confirmFunc) {
            await alertList[alertId].confirmFunc();
        }
        closeAlert();
    };

    try {
      return (
        <>
          <AlertDialog            
            isOpen={alertList?.hasOwnProperty(alertId)}
            blockScrollOnMount={false}
            leastDestructiveRef={cancelRef}
            onOverlayClick={() => {closeAlert()}}
          >
            <AlertDialogOverlay>
              <AlertDialogContent width="85%" maxWidth="500px">
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                  {alertList?.[alertId]?.header ? alertList[alertId].header : ""}
                </AlertDialogHeader>
                <AlertDialogBody>
                  <Markup content={
                      //if error object is passed, get the actual string part of it or interweave will freak out
                      alertList?.[alertId]?.body?.message
                        ?
                            alertList[alertId].body.message
                        :
                            alertList[alertId].body
                  }/>

                </AlertDialogBody>

                <AlertDialogFooter>
                  {
                    alertList?.[alertId]?.declineFunc
                        ?
                            <Button ref={cancelRef} onClick={handleDecline}>
                                {alertList?.[alertId]?.declineLabel ? alertList[alertId].declineLabel : "Cancel"}
                            </Button>
                        :
                            []
                  }
                  <Button colorScheme='red' onClick={handleConfirm} ml={3}>
                    {alertList?.[alertId]?.confirmLabel ? alertList[alertId].confirmLabel : "OK"}
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </>
      );
    } catch (e) {
      console.error("AlertComponent render error: ", e);
    }
}
